import { Environment } from "./types"

export const isProd = () => {
  if (window.location.href.includes(Environment.PRODUCTION)) {
    return true;
  }
  
  return false;
}

export const namespace = 'https://globalga-dd72c14a7767.herokuapp.com';
